import { useCallback } from "react";
import { useRequest } from "ahooks";
import { Select, message } from "antd";
import {
  setting as settingService,
  message as messageService,
} from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function PublicationSelect({ messageId, defaultValue, callback }) {
  const auth = useAuthContext();
  const { data = { results: [] }, loading } = useRequest(
    () => settingService.listPublication({}, auth.token),
    {
      ready: !!auth.token,
      refreshDeps: [auth.token],
    }
  );

  const changeHandler = useCallback(
    (value) => {
      messageService
        .partialUpdateMessage(messageId, { publication: value }, auth.token)
        .then(() => {
          message.success("操作成功");
          callback(Date.now());
        })
        .catch((err) => {
          message.error(err.message || err);
        });
    },
    [messageId, callback, auth]
  );

  const optionItems = data.results.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.name}
    </Select.Option>
  ));

  return (
    <Select
      loading={loading}
      defaultValue={defaultValue}
      allowClear={true}
      onChange={changeHandler}
      style={{ width: "80px" }}
      placeholder="空"
    >
      {optionItems}
    </Select>
  );
}

export default PublicationSelect;
